import { render } from "./menutop.vue?vue&type=template&id=5dea1125&scoped=true"
import script from "./menutop.vue?vue&type=script&lang=js"
export * from "./menutop.vue?vue&type=script&lang=js"

import "./menutop.vue?vue&type=style&index=0&id=5dea1125&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dea1125"]])

export default __exports__